import { getStateWithOnlyOneLevel } from '../../utilities/StateSelectorHelper';

function getState(state) {
  return getStateWithOnlyOneLevel(state, 'selfPromotion');
}

export const getConfigsSelector = (state) => getState(state).get('configs');
export const getCyclesSelector = (state) => getState(state).get('cycles');
export const getLoadingSelector = (state) => getState(state).get('loading');
